import React from 'react';
import { PapiComment } from '@wix/da-papi-types';
import { EditingState } from '../../redux/types';
import CommentSkeleton, { CommentSkeletonProps } from '../../lego/CommentSkeleton';
import SpamView from '../../commonSkeletonViews/SpamView';
import HiddenView from '../../commonSkeletonViews/HiddenView';
import EditView, { EditViewProps } from '../../commonSkeletonViews/EditView';
import ReadView, { ReadViewProps } from './ReadView';

export interface Props
  extends
    ReadViewProps,
    Pick<EditViewProps, 'onCommentUpdated'>,
    Pick<CommentSkeletonProps, 'orphanView' | 'extraActions'> {
  comment: PapiComment;
  className?: string;
  onEditingStateChange?: (state: EditingState) => void;
}

const Comment: React.FC<Props> = ({
  comment,
  canPostComment,
  includeFooter,
  className,
  orphanView,
  onReplyPosted,
  onEditingStateChange,
  onCommentUpdated,
  extraActions,
}) => {
  return (
    <CommentSkeleton
      className={className}
      comment={comment}
      onEditingStateChange={onEditingStateChange}
      readView={
        <ReadView
          includeFooter={includeFooter}
          canPostComment={canPostComment}
          onReplyPosted={onReplyPosted}
        />
      }
      spamView={<SpamView />}
      hiddenView={<HiddenView />}
      editingView={<EditView canPostComment={canPostComment} onCommentUpdated={onCommentUpdated} />}
      extraActions={extraActions}
      // Some usages of this preset provide their own orphanView
      // TODO: Clean that up. Create a new preset over there instead?
      orphanView={orphanView}
    />
  );
};
Comment.displayName = 'Comment';

export default Comment;
